import { render, staticRenderFns } from "./MemoryCard.vue?vue&type=template&id=7c6f58fe&scoped=true"
import script from "./MemoryCard.vue?vue&type=script&lang=js"
export * from "./MemoryCard.vue?vue&type=script&lang=js"
import style0 from "./MemoryCard.vue?vue&type=style&index=0&id=7c6f58fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f58fe",
  null
  
)

export default component.exports